import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PPTBillPayment } from 'egov-api';

@Component({
    selector: 'ppt-paid-on',
    template: `
        <ng-container *ngIf="payment?.date">{{ payment!.date | date }}</ng-container>
        <span *ngIf="!payment?.date" class="unimportant-text">&ndash;</span>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PPTPaidOnComponent
{
    @Input() protected payment?: PPTBillPayment;
}
